import {Dialog} from "./common";
import {range} from "../helpers/column_names";
import group from "../operations/undo_group";

export const action = "add-dropdown";

export class DialogBox extends Dialog{
	$show(){
		let form = this.$dialog.$$("form");
		this.cell = this.view.getSelectedId(true);
		if (!this.cell.length)
			return false;

		form.clear();

		//restore previosly selected range
		const value = this.view.getCellEditor(this.cell[0].row, this.cell[0].column);
		if(value)
			form.setValues({
				range: value.options,
				empty: value.empty
			});

		this.view.$handleSelection = function(st, end, a, b){
			form.elements.range.setValue(a+":"+b);
			return false;
		};

		form.elements.range.focus();
	}
	$hide(){
		this.view.$handleSelection = null;
	}
	$init(){
		return {
			view: "ssheet-dialog",
			position:"center",
			head:webix.i18n.spreadsheet.labels["dropdown-title"],
			move: true,
			body:{
				padding:0,
				view:"form",
				id:"form",
				elementsConfig: {
					labelWidth: 130
				},
				rows:[
					{ view:"text", label:webix.i18n.spreadsheet.labels["dropdown-range"], name:"range" },
					{ view:"checkbox", label:webix.i18n.spreadsheet.labels["dropdown-empty-option"], name:"empty" }
				]
			},
			on:{
				onSaveClick: () => this.okClick(),
				onCancelClick: () => this.close()
			}
		};
	}
	okClick(){
		const values = this.$dialog.$$("form").getValues();

		if(!range(values.range, this.view))
			this.view.alert({text:webix.i18n.spreadsheet.labels["error-range"], type: "alert-error"});
		else{
			group.set(function(){
				for (let i = 0; i < this.cell.length; i++)
					this.view.setCellEditor(this.cell[i].row, this.cell[i].column, { editor:"ss_richselect", options:values.range, empty:values.empty });
			}, this);
			this.close();
		}
	}
}